<template>
    <Radar
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
  </template>
  
  <script>
  import { Radar } from 'vue-chartjs/legacy';
  import { Chart as ChartJSPrint, Title, Tooltip, Legend, PointElement, LineElement, RadialLinearScale } from 'chart.js';
  
  ChartJSPrint.register(Title, Tooltip, Legend, PointElement, RadialLinearScale, LineElement);
  
  export default {
    name: 'RadarChart',
    components: {
      Radar
    },
    props: {
      chartId: {
        type: String,
        default: 'radar-chart'
      },
      datasetIdKey: {
        type: String,
        default: 'label'
      },
      width: {
        type: Number,
        default: 400
      },
      height: {
        type: Number,
        default: 400
      },
      cssClasses: {
        default: '',
        type: String
      },
      styles: {
        type: Object,
        default: () => ({})
      },
      plugins: {
        type: Array,
        default: () => []
      },
      chartData: {
        type: Object,
        default: () => ({
          labels: ['Matematika', 'Fisika', 'Kimia', 'Biologi', 'B. Inggris', 'B. Indonesia'],
          datasets: [
            {
              label: 'Pencapaian',
              data: [90, 75, 90, 82, 78, 90],
              backgroundColor: 'rgba(255,218,0,0.8)',
              borderColor: '#FFDA00',
              fill: true
            },
            {
              label: 'Saran',
              data: [90, 90, 90, 87, 90, 65],
              backgroundColor: 'rgba(214,0,255,0.8)',
              borderColor: '#D600FF'
            }
          ]
        })
      },
      fontColor: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        chartOptions: {
          scales: {
              min: 0,
              max: 100,
              r: {
                  angleLines: {
                      display: false
                  },
                  pointLabels: {
                      font: {
                          size: 14
                      }
                  },
                  ticks: {
                      display: false,
                  }
              }
            }
        }
      };
    },
    created() {
      // ChartJSPrint.defaults.color       = '#7e7e7e';
      // ChartJSPrint.defaults.borderColor = '#7e7e7e';
      // ChartJSPrint.defaults.font.family = "'Cerebri Sans',sans-serif";

      ChartJSPrint.defaults.color = '#ffffff';
      ChartJSPrint.defaults.borderColor = '#2E2FCA';
      ChartJSPrint.defaults.font.family = "'Cerebri Sans',sans-serif";

    }
  };
  </script>
  